import { animate, IDirective } from 'angular';

export function gmcCollapseDirective( $animate: animate.IAnimateService,
                                      $animateCss: animate.IAnimateCssService ): IDirective {
  return {
    restrict: 'A',
    link: function postLink( scope, element, attrs ) {
      const expandDuration: number = parseFloat(attrs.duration) || 0.6;
      element.css({ overflow: 'hidden' });

      function collapse() {
        $animateCss(element, {
          easing: 'ease',
          to: {
            height: '0'
          },
          duration: expandDuration
        }).start();
      }

      function expand() {
        $animateCss(element, {
          easing: 'ease',
          from: {
            height: '0'
          },
          to: {
            height: getScrollHeight()
          },
          duration: expandDuration
        }).start();
      }

      function getScrollHeight(): string {
        return element[ 0 ].scrollHeight + 'px';
      }

      attrs.$observe('gmcCollapse', ( isCollapse: string ) => {
        if ( !!scope.$eval(isCollapse) ) {
          collapse();
        } else {
          expand();
        }
      });
    }
  };
}

gmcCollapseDirective.$inject = [ '$animate', '$animateCss' ];



// WEBPACK FOOTER //
// ./app/shared/directives/gmc-collapse/gmc-collapse.directive.ts